import { AvailableModules, Features } from 'generated/featureDefinitions'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { RequestUpgradeProps } from 'modules/upsell/lib/requestUpgradeTypes'

export const featureToRequest = (): RequestUpgradeProps => ({
  moduleRequested: AvailableModules.documents,
  featureRequested: Features.analytics_advanced_reports,
  requestSource: 'Upsell modal with feature info',
  requestReason: ValidReasons.MissingFeature,
})
